import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootReducer from 'redux/reducers';
import rootSaga from 'redux/sagas';

import { persistStore, persistReducer } from 'redux-persist';

const sagaMiddleware = createSagaMiddleware();

const isProduction = process.env.NODE_ENV === 'production';

const middleware = isProduction ? [sagaMiddleware] : [sagaMiddleware];
const defaultMiddleware = getDefaultMiddleware({ serializableCheck: false });

export const store = configureStore({
  reducer: rootReducer,
  middleware: [...defaultMiddleware, ...middleware],
  devTools: !isProduction,
});

sagaMiddleware.run(rootSaga);

export const persistor = persistStore(store);

export default { store, persistor };
